// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  endpoints: {
    authority: 'https://signin.techsys.co.za/realms/techsys',
    api: 'https://localhost:44390',
    status_ui: 'https://localhost:44389',
    status_api: 'https://localhost:44389/api/health'
  },
  authentication: {
    appId: 'allsafe',
    appSecret: '7LzHZrhHuysnGwa6v6sTcqfJpS2kNZwW',
    scopes: 'openid profile email roles allsafe',
    showDebug: false,
    enableSessionChecks: true,
    requireHttps: false,
    silentRefreshShowIFrame: false
  },
  storage: {
    apiSurface: 'endpoints',
  },
  messageBus: {
    defaultHub: 'odin'
  },
  ui: {
    appName: 'AllSafe',
    appDescription: 'Powered by Techsys Digital',
    defaultProfile: '../../assets/img/profile_blank.png',
    defaultTheme: 'B',
    supportAddress: 'ops@techsys.co.za',
    supportContact: 'Ops Team',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
